import React from "react";

import Service from "./Service";
import Markdown from "react-markdown";


const ServiceCategory = (props) => {

    return <article>
        <h2>{ props.title }</h2>
        <p><em>{ props.hook }</em></p>
        <Markdown>{ props.description }</Markdown>
        {
            props.services.map((data, idx) => {
                return <Service 
                    key={idx}
                    title={data.title}
                    content={data.description}
                />
            })
        }
    </article>
}

ServiceCategory.defaultProps = {
    title: "Construction",
    services: [
        {
            title: "Development Analysis",
            description: "We assess project feasibility, zoning, and site constraints to inform early decisions and reduce downstream risks."
        }
    ],
    hook: "Hook here!"
};

export default ServiceCategory